import { render, staticRenderFns } from "./changeNum.vue?vue&type=template&id=2fb1c881&scoped=true"
import script from "./changeNum.vue?vue&type=script&lang=js"
export * from "./changeNum.vue?vue&type=script&lang=js"
import style0 from "./changeNum.vue?vue&type=style&index=0&id=2fb1c881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1c881",
  null
  
)

export default component.exports